var render, staticRenderFns
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Item.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/Sidebar/Item.vue
// module id = null
// module chunks = 